import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import css from './css.module.less';
import { OriSelect } from '@/src/components/Antd';
const Option = OriSelect.Option;
import SectionHOC from '../HOC';
import { StyledTitle } from 'src/layout/EditorPageLayout/SectionTitle';
import {
  EnumCollapseId,
  getDenomination,
  getSalesChannels,
  getSalesChannelUsage,
  onSalesChannelUsageUuidsChange,
} from '../slice';
import { getSalesChannels as getGlobalSalesChannels } from 'src/constrains/GlobalProvider/slice';
import { getI18nFromGeneral } from '@/src/tools/tools';
const SalesChannelUsage = (props) => {
  const salesChannels = useSelector(getSalesChannels());
  const globalSalesChannels = useSelector(getGlobalSalesChannels());
  const currencyData = useSelector(getDenomination());
  const { currency } = currencyData || {};
  const avaSalesChannels = React.useMemo(() => {
    // console.log('salesChannels', salesChannels);
    const _s = (salesChannels || globalSalesChannels).filter((i) => {
      return [...(i.availableCurrencies || []), i.currency].includes(currency);
    });
    return _s || [];
  }, [currency, salesChannels, globalSalesChannels]);

  const data = useSelector(getSalesChannelUsage()) || [];

  const d = useDispatch();
  const handleOnUuidsChange = (uuids) => {
    d(onSalesChannelUsageUuidsChange(uuids));
  };
  return (
    <OriSelect
      disabled={props.disabled}
      className={css.select}
      value={data}
      mode='multiple'
      onChange={handleOnUuidsChange}
      size='large'>
      {avaSalesChannels.map((i) => {
        const { uuid, name } = i;
        return (
          <Option value={uuid} key={uuid}>
            {name}
          </Option>
        );
      })}
    </OriSelect>
  );
};
export default SectionHOC(SalesChannelUsage, {
  id: EnumCollapseId.SalesChannelUsage,
  title: (
    <StyledTitle
      left={getI18nFromGeneral('general.hOCTitle.salesChannelUsage')}
    />
  ),

  useCustomCollapseTitle: true,
  useDefaultCollapseContent: true,
});
